import React, { useEffect, useState } from "react";
import "./AddInterview.css";
import { useFormik } from "formik";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router";
import { addadminlist } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Required";
  }
  if (!values.email) {
    errors.email = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.phonenumber) {
    errors.phonenumber = "Required";
  }
  return errors;
};

const AddSubadmin = () => {
  const [load, setload] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterr] = useState("");

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phonenumber: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const response = await addadminlist(values);
      navigate("/Editors_List");
      setload(false);
    } catch (error) {
      seterr(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Add Editors</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Editor Name</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="name"
              type="text"
              placeholder=" Name"
              minLength={1}
              maxLength={200}
              // value={data.name}
              className="Auth_input"
            />
            {formik.errors.question_text ? (
              <p className="invalid">{formik.errors.name} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Editor Email</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="email"
              type="email"
              placeholder=" Email"
              minLength={1}
              maxLength={100}
              className="Auth_input"
            />
            {formik.errors.email ? (
              <p className="invalid">{formik.errors.email} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Editor PhoneNumber</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="phonenumber"
              type="phonenumber"
              placeholder=" phonenumber"
              minLength={1}
              maxLength={100}
              className="Auth_input"
            />
            {formik.errors.phonenumber ? (
              <p className="invalid">{formik.errors.phonenumber} </p>
            ) : null}
          </div>

          <button className="term_button" type="Submit">
            Save
          </button>
        </form>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default AddSubadmin;
